<template>
  <div>
    <a-modal
      :title="isNew ? '新增' : '修改'"
      :visible="isShow"
      width="700px"
      okText="确定"
      cancelText="取消"
      @ok="onSave"
      class="customermodel"
      @cancel="isShow = false"
      :confirmLoading="isSaving"
    >
      <div class="editsimulationfood-model">
        <a-form-model
          ref="studentGroupForm"
          :model="dailyFoodMenu"
          :rules="rules"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
        >
          <a-form-model-item label="日期" prop="date">
            <a-date-picker
              style="width:80%"
              size="large"
              value-format="YYYY-MM-DD"
              v-model="dailyFoodMenu.date"
            />
          </a-form-model-item>
          <a-form-model-item ref="meal_type" label="餐次" prop="meal_type">
            <a-select
              size="large"
              placeholder="请选择餐次"
              style="width:80%"
              v-model="dailyFoodMenu.meal_type"
            >
              <a-select-option
                :value="item.value"
                v-for="(item, index) in mealTypeList"
                :key="index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <template v-for="(food,index) in dailyFoodMenu.foods">
            <a-form-model-item :label="'菜品' + (index+1)" :key="index" :rules="[{ required: true }]" >
            <a-row>
              <a-col :span="13">
                <a-input placeholder="请输入菜品名称" @input="checkInput('name', food)" size="large" v-model="food.name" />
              </a-col>
              <a-col :span="10" :offset="1">
                重量：
                <a-input
                  @input="checkInput('weight', food)"
                  placeholder="不填写,则随机生成"
                  v-model="food.weight"
                  size="large"
                  suffix="克"
                  style="width:180px"
                />
                <a-icon class="delete-button" v-if="index>0" type="minus-circle-o" @click="removeFood(index)" />
              </a-col>
            </a-row>
          </a-form-model-item>
          </template>
          <a-row>
            <a-col :span="19" :offset="3">
              <a-button type="dashed" style="width:120px" @click="addFood()">添加菜单</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </a-modal>
  </div>
   <!-- <a-modal
       :title="isNew ? '新增' : '修改'"
      :visible="isShow"
      @ok="onSave"
      @cancel="isShow = false"
      class="customermodel"
      width="700px"
      :centered="true"
      :confirmLoading="isSaving"
    >
      <div class="editsimulationfood-model">
        <a-form :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }" ref="studentGroupForm"
          :model="dailyFoodMenu"
          :rules="rules">
          <a-form-item label="日期" prop="date">
            <a-date-picker size="large" style="width:100%" value-format="YYYY-MM-DD"
              v-model="dailyFoodMenu.date" />
          </a-form-item>
          <a-form-item ref="meal_type" label="餐次" prop="meal_type">
            <a-select v-model="dailyFoodMenu.meal_type" size="large" placeholder="请选择餐次">
              <a-select-option
                :value="item.value"
                v-for="(item, index) in mealTypeList"
                :key="index"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <template v-for="(food,index) in dailyFoodMenu.foods">
            <a-form-item label="菜单" :key="index">
            <a-row>
              <a-col :span="13">
                <a-input placeholder="请输入菜单" size="large" v-decorator="['name',{rules: [{ required: true, message: '姓名不能为空！' }]}]" />
              </a-col>
              <a-col :span="10" :offset="1">
                重量：
                <a-input
                v-decorator="['weight',{rules: [{ required: true, message: '姓名不能为空！' }]}]"
                  placeholder="不填写,则随机生成"
                  size="large"
                  suffix="克"
                  style="width:180px"
                />
                <a-icon class="delete-button" type="minus-circle-o" @click="removeFood(index)" />
              </a-col>
            </a-row>
          </a-form-item>
          </template>
          <a-row>
            <a-col :span="19" :offset="3">
              <a-button type="dashed" style="width:120px" @click="addFood()">添加菜单</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal> -->
</template>

<script>
import apis from '@/business/apis'
import { mapState } from 'vuex'

const formItemLayout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 20 }
}
const formTailLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 18 }
}

export default {
  name: 'DailyFoodMenu',
  inject: ['eventBus'],
  data: () => ({
    id: false,
    isShow: false,
    dailyFoodMenu: {},
    isSaving: false,
    formItemLayout,
    formTailLayout,
    isNew: false,
    rules: {
      date: [{ required: true, message: '请选择日期' }],
      foods: [{ required: true, message: '请选择菜系' }],
      meal_type: [{ required: true, message: '请选择餐次' }]
    },
    mealTypeList: [
      { name: '早餐', value: 'breakfast' },
      { name: '午餐', value: 'lunch' },
      { name: '晚餐', value: 'dinner' },
      { name: '宵夜', value: 'nightSnack' }
    ]
  }),
  computed: {
    ...mapState('school', ['currentSchool'])
  },
  methods: {
    async show (id = false) {
      this.isNew = true
      this.dailyFoodMenu = { foods: [{ name: '' }] }
      this.id = id
      if (this.id) {
        await this.loadDetail()
        this.isNew = false
      }
      this.isShow = true
    },
    addFood () {
      this.dailyFoodMenu.foods.push({ name: '' })
    },
    removeFood (index) {
      this.dailyFoodMenu.foods.splice(index, 1)
    },
    checkInput (type, item) {
      if (type === 'name') {
        if (item.name.length > 20) {
          item.name = item.name.substr(0, 20)
        }
      } else if (type === 'weight') {
        item.weight = item.weight
          .replace(/[^\d.]/g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
          .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$2.$3')
          .replace(/^\./g, '')
        item.weight = Number(item.weight) || undefined
      }
    },
    async loadDetail () {
      const response = await this.$http.get(apis.dailyFoodMenu.detail + this.id)
      const result = response.body
      console.log(result)
      this.dailyFoodMenu = result.dailyFoodMenu
      if (!this.dailyFoodMenu.foods || !this.dailyFoodMenu.foods.length) {
        this.dailyFoodMenu.foods = [{ name: '' }]
      }
      for (let i = 0; i < this.dailyFoodMenu.foods.length; i++) {
        const item = this.dailyFoodMenu.foods[i]
        if (typeof item === 'string') {
          this.dailyFoodMenu.foods[i] = { name: item } // 字符串转成对象
        } else {
          item.weight = item.weigth || item.weight
        }
      }
    },
    onSave () {
      this.$refs.studentGroupForm.validate(valid => {
        if (!valid) return
        if (!this.dailyFoodMenu.foods || !this.dailyFoodMenu.foods.length) {
          this.$message.warn('菜品不能为空！')
          return
        }
        for (let i = 0; i < this.dailyFoodMenu.foods.length; i++) {
          const item = this.dailyFoodMenu.foods[i]
          if (!item.name) {
            this.$message.warn('请输入菜品名称')
            return
          }
        }
        this.save()
      })
    },
    async save () {
      this.isSaving = true
      this.dailyFoodMenu.school_id = this.currentSchool.id
      let url = apis.dailyFoodMenu.save
      if (this.id) url += `/${this.id}`

      const response = await this.$http.post(url, this.dailyFoodMenu)
      const result = response.body
      console.log(result)

      this.isSaving = false
      if (result.success) {
        this.isShow = false
        this.$emit('saved')
      }
    }
  },
  created () {
    this.eventBus.$on('show-daily-food-menu-edit', this.show)
  },
  beforeDestroy () {
    this.eventBus.$off('show-daily-food-menu-edit', this.show)
  }
}
</script>
